
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
// import '@/style/bootstrap.min.css';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import moment from 'moment'
import * as echarts from 'echarts'


/*
router.beforeEach( (to,from,next) => {
    if(!localStorage.getItem("uid")) {
        if(to.path !== '/login') {
            next("/login")
        } else next()
    } next()
})*/

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(moment)


app.use(router);

app.use(ElementPlus)

app.use(echarts)

app.config.globalProperties.target = 'http://localhost:9000/'

app.mount('#app')



